import hk from './hk'
import cn from './cn'

module.exports = {
	hk, cn
}


// WEBPACK FOOTER //
// ./js/src/i18n/common/index.js